export default {
    getLogsCocoon: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'cocoon'
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsCocoon/api.js